import { createReducer, on } from '@ngrx/store';
import { login, logout, loginFailure, setPermissions, setPermissionsFailure } from './auth.actions';
import { AuthState, initialAuthState } from './auth.state';
import { JwtService } from '../../services/utilities/jwt-service';

export const authReducer = createReducer<AuthState>(
  initialAuthState,
  // When the user logs in, update token and user details
  on(login, (state, { token, user }) => {
    const email = user?.email ?? JwtService.getEmailFromToken(token); // make sure we always have a valid email after login
    return {
      ...state,
      token,
      user: { email, id: user?.id, role: user?.role },
      errorLogs: [],
    };
  }),
  // When the user logs out, reset to the initial state
  on(logout, () => initialAuthState),
  // When login fails, update the error field
  on(loginFailure, (state, { error }) => {
    let errorLogs = state.errorLogs;
    errorLogs.push(error);
    return {
      ...state,
      errorLogs,
    };
  }),
  on(setPermissions, (state, { permissions }) => {
    return {
      ...state,
      roles: permissions,
    };
  }),
  on(setPermissionsFailure, (state, { error }) => {
    let errorLogs = state.errorLogs;
    errorLogs.push(error);
    return {
      ...state,
      errorLogs,
    };
  })
);
